/* eslint-disable */
export default {
    competencies_competency_development_oriented: "Entwicklungsorientierung",
    competencies_competency_attentive_listening: "Aufmerksames Zuhören",
    competencies_competency_adaptability: "Anpassungsvermögen",
    competencies_competency_direction: "Anleiten",
    competencies_competency_analytical_capabilities: "Analytische Fähigkeiten",
    competencies_competency_autonomy: "Autonomie",
    competencies_competency_accompaniment: "Begleitung",
    competencies_competency_resolution: "Tatkraft",
    competencies_competency_collaboration_promotion: "Förderung der Zusammenarbeit",
    competencies_competency_coaching: "Coachen",
    competencies_competency_collegiality: "Kollegialität",
    competencies_competency_commercial_drive: "Kommerzieller Elan",
    competencies_competency_communicative_flexibility: "Kommunikative Flexibilität",
    competencies_competency_decisiveness_competencies: "Entschlussfähigkeit",
    competencies_competency_delegation: "Delegieren",
    competencies_competency_persistent_questioning: "Nachfragen",
    competencies_competency_work_efficiency: "Effizient arbeiten",
    competencies_competency_kindle_enthusiasm: "Begeisterungsfähigkeit",
    competencies_competency_external_orientation: "Externe Orientierung",
    competencies_competency_financial_insight: "Finanzielle Bildung",
    competencies_competency_flexibility: "Flexibilität",
    competencies_competency_improvisation: "Improvisieren",
    competencies_competency_initiative: "Initiative",
    competencies_competency_innovative_thinking: "Innovativ denken",
    competencies_competency_integrity: "Integrität",
    competencies_competency_interpersonal_sensitivity: "Zwischenmenschliche Sensitivität",
    competencies_competency_effort: "Einsatz",
    competencies_competency_client_orientation: "Kundenorientierung",
    competencies_competency_quality_orientation: "Qualitätsorientierung",
    competencies_competency_oral_communication: "Mündlich kommunizieren",
    competencies_competency_exactness: "Genauigkeit",
    competencies_competency_judgement: "Urteilsbildung",
    competencies_competency_openness_to_change: "Offen für Veränderungen",
    competencies_competency_organisation_sensitivity: "Organisationssensitivität",
    competencies_competency_persuasiveness: "Überzeugungskraft",
    competencies_competency_planning_and_organisation: "Planen und organisieren",
    competencies_competency_practicality: "Praktisch handeln",
    competencies_competency_problem_solving_capability: "Fähigkeit zur Problemlösung",
    competencies_competency_arithmetic_proficiency: "Rechenfähigkeit",
    competencies_competency_managing_relationships: "Beziehungsmanagement",
    competencies_competency_results_orientation: "Ergebnisorientierung",
    competencies_competency_written_communication: "Schriftlich kommunizieren",
    competencies_competency_service_orientation: "Dienstleistungsorientierung",
    competencies_competency_social_versatility: "Soziale Beweglichkeit",
    competencies_competency_firmness: "Standfestigkeit",
    competencies_competency_stress_resistance: "Stressbeständigkeit",
    competencies_competency_tact: "Takt",
    competencies_competency_explanation_and_clarification_skills: "Erläutern und Verdeutlichen",
    competencies_competency_expertise: "Kompetenz",
    competencies_competency_tenacity: "Beharrlichkeit",
    competencies_competency_sense_of_responsibility: "Verantwortungsgefühl",
    competencies_competency_ingenuity: "Einfallsreichtum",
    competencies_competency_vision: "Vision",
    competencies_competency_monitoring: "Fortschrittskontrolle",
    competencies_competency_carefulness: "Sorgfältigkeit",
    report_conformity: "Anpassungen",
    report_independence: "Unabhängig",
    report_altruism: "Altruismus",
    report_leadership: "Führen",
    report_support_and_recognition: "Unterstützung und Anerkennung",
    report_materialism: "Materialismus",
    report_indulgence: "Nachgiebigkeit",
    report_general_ability: "Allgemeine Intelligenz",
    competencies_competency_inclusivity: "Inklusivität",
    persona_fit_role_to_be_go_getter: "Anpacker",
    persona_fit_role_to_be_expert: "Spezialist",
    persona_fit_role_to_be_controller: "Überwacher",
    persona_fit_role_to_be_coordinator: "Koordinator",
    persona_fit_role_to_be_connector: "Brückenbauer",
    persona_fit_role_to_be_inspirator: "Motivator",
    persona_fit_role_to_be_innovator: "Innovator",
    persona_fit_role_to_be_entrepreneur: "Unternehmer",
    abstractAbility: "Abstrakte Intelligenz",
    verbalAbility: "Verbale Intelligenz",
    numericalAbility: "Numerische Intelligenz",
    oprecht: "Direkt",
    Extraversie: "Extraversion",
    "Emotionele.stabiliteit": "Emotionale Stabilität",
    "Openheid.van.geest": "Offener Geist",
    Conscientieusheid: "Gewissenhaftigkeit",
    "Behoefte.aan.affiliatie": "Bedürfnis nach Verbundenheit",
    "Behoefte.aan.autonomie": "Bedürfnis an Autonomie",
    "Behoefte.aan.macht": "Bedürfnis nach Macht",
    "Behoefte.aan.prestatie": "Bedürfnis nach Leistung",
    Berekenend: "Antizipierend",
    Assertief: "Durchsetzungsvermögen",
    Manipulatief: "Sozial geschickt",
    Rechtdoorzee: "Aufrichtig",
    Doortastend: "Ist resolut",
    "Extrinsieke.prestatiemotivatie": "Erfolgsstreben",
    "Intrinsieke.prestatiemotivatie": "Qualitätsstreben",
    "Negatieve.faalangst": "Unsicherheit über Leistungen",
    Ontwikkelingsgericht: "Entwicklungsorientierung",
    "Positieve.faalangst": "Braucht Herausforderungen",
    Behulpzaamheid: "Hilfsbereitschaft",
    Dominantie: "Dominanz",
    Nuchterheid: "Nüchternheit",
    "Onafhankelijk.denken": "Unabhängiges Denken",
    Optimisme: "Optimismus",
    "Relationele.stressbestendigheid": "Relationale Stressbeständigkeit",
    "Taakgerelateerde.stressbestendigheid": "Aufgabenbezogene Stressbeständigkeit",
    Sociabiliteit: "Umgänglichkeit",
    "Systematisch.werken": "Systematisches Arbeiten",
    Veranderingsgericht: "Veränderungsorientierung",
    Verantwoordelijkheid: "Verantwortlichkeit",
    Verbeelding: "Vorstellungskraft",
    Vertrouwen: "Vertrauen",
    Vriendelijkheid: "Freundlichkeit",
    Zelfdiscipline: "Selbstdisziplin",
    agility: "Resilienz",
    energy: "Energie",
    growthMindset: "Wachstumsorientierung",
    selfManagement: "Selbstmanagement",
    Proud: "Stolz",
    willingnessToTakeRisks: "Risikobereitschaft",
    attention_emotionele_stabiliteit_3_extraversie_3_vriendelijkheid_3: "Bezieht die Unsicherheiten anderer in die Überlegungen mit ein",
    hexit_explosief: "Temperamentvoll",
    hexit_meedogenloos: "Unerbittlich",
    hexit_egocentrisch: "Egozentrisch",
    hexit_machiavellistisch: "Gerissen",
    hexit_rigoureus: "Eigenständig",
    hexit_micromanager: "Kontrollierend",
    hexit_perfectionistisch: "Perfektionistisch",
    hexit_autopiloot: "Starre",
    hexit_behoedzaam: "Vorsichtig",
    hexit_lichtzinnig: "Nonchalant",
    hexit_chaotisch: "Chaotisch",
    hexit_roekeloos: "Rücksichtslos",
    hexit_afstandelijk: "Distanziert",
    hexit_koppig: "Starrköpfig",
    hexit_cynisch: "Zynisch",
    hexit_passiefAgressief: "Untergrabend",
    hexit_volgzaam: "Docile",
    hexit_theatraal: "Theatralisch",
    hexit_paranoide: "Kritisch",
    hexit_anarchistisch: "Rebellisch",
    competencies_competency_intellectual_capability: "Intellektuelle Fähigkeiten",
    cp_talent_analytics_title: "Talent-Analytik",
    cp_talent_analytics_chosen_filters: "Ausgewählte Filter:",
    cp_talent_analytics_empty_title: "Noch keine Gruppenberichte",
    cp_talent_analytics_empty_text: "Es liegen (noch) keine Gruppenberichte vor. Speichern Sie Ihr erstes Dashboard in der Teilnehmerübersicht, um hier Ihren Gruppenbericht anzuzeigen.",
    cp_talent_analytics_empty_redirect_button: "Zur Teilnehmerübersicht",
    cp_talent_analytics_empty_instruction_title: "Wie funktionieren Gruppenberichte?",
    cp_talent_analytics_empty_instruction_text: "Hier sehen Sie, wie der Ablauf beim Anfordern eines Gruppenberichts funktioniert",
    cp_talent_analytics_empty_instruction_step_one: "Wählen Sie in der Teilnehmerübersicht die Personengruppe(n) aus, die in Ihrem Gruppenbericht enthalten sein sollen",
    cp_talent_analytics_empty_instruction_step_two: "Öffnen Sie das gewünschte Dashboard (Management-Dashboard, Ranking oder Kultur-Dashboard).",
    cp_talent_analytics_empty_instruction_step_three: "Speichern Sie das Dashboard, damit sie hier angezeigt werden",
    cp_talent_analytics_empty_instruction_step_four: "Gehen Sie zu Ihrem Gruppenbericht, wann Sie die Ergebnisse sehen möchten",
    cp_talent_analytics_recent_reports_title: "Aktuelle(r) Bericht(e)",
    cp_talent_analytics_recent_reports_subtitle: "Hier finden Sie die aktuellsten Gruppenberichte.",
    cp_talent_analytics_other_reports_title: "Anderer Bericht(e)",
    cp_talent_analytics_other_reports_subtitle: "In der Liste unten finden Sie alle weiteren Gruppenberichte.",
    cp_talent_analytics_recent_reports_view_button: "Anschauen",
    cp_talent_analytics_no_filters_selected: "Keine Filter ausgewählt",
    cp_participants_dashboards_title_toxics: "",
    cp_talent_analytics_search: "Suchen...",
    cp_talent_analytics_group_type_filter: "Art des Berichts",
    cp_talent_analytics_previous_page: "Vorherige",
    cp_talent_analytics_next_page: "Weiter",
    cp_talent_analytics_back_to_overview: "Zurück zur Talent Analytics-Übersicht",
    cp_talent_analytics_share_report_modal_title: "Teilen Sie den Bericht",
    cp_talent_analytics_share_report_modal_text: "Wählen Sie die Personen aus, für die Sie den Bericht freigeben möchten. Sie können einen vorhandenen Benutzer auswählen oder einen neuen Benutzer hinzufügen. Die ausgewählten Personen erhalten eine E-Mail, um sie zu informieren.",
    cp_talent_analytics_share_report_modal_add_new_user_button: "Neuer Benutzer",
    cp_talent_analytics_add_new_user_modal_title: "Neuen Benutzer anlegen für",
    cp_talent_analytics_add_new_user_modal_text: "Geben Sie hier die Details eines Benutzers an, der Zugriff auf den Gruppenbericht benötigt.",
    cp_talent_analytics_add_new_user_modal_save_button: "Benutzer speichern und einladen",
    cp_talent_analytics_add_new_user_modal_select_user: "Benutzer auswählen",
    cp_talent_analytics_add_new_user_modal_select_add_new: "Neuen Benutzer hinzufügen",
    cp_talent_analytics_share_report_modal_display_users_title: "Dieser Bericht wird geteilt mit:",
    cp_talent_analytics_share_report_modal_display_users_owner: "Ersteller/ Besitzer",
    cp_talent_analytics_share_report_modal_display_users_can_view: "Kann anzeigen",
    cp_talent_analytics_share_report_button: "Teilen",
    cp_talent_analytics_share_report_modal_display_users_remove_button: "Entfernen",
    cp_talent_analytics_share_report_modal_select_placeholder: "Beginnen Sie mit der Eingabe des Benutzernamens ...",
    cp_talent_analytics_remove_access_modal_title: "Zugang zum Bericht entfernen",
    cp_talent_analytics_remove_access_modal_text: "Das bedeutet, dass er/sie diesen Bericht nicht mehr in seiner/ihrer Übersicht sieht und ihn nicht mehr über einen Link oder auf andere Weise öffnen kann. Möchten Sie den Zugriff wirklich entziehen?",
    cp_talent_analytics_remove_access_modal_remove_button: "Zugriff entfernen",
    cp_talent_analytics_remove_access_modal_cancel_button: "Abbrechen",
    cp_talent_analytics_remove_access_modal_text_with_name: "Sie werden den Zugriff auf diesen Bericht für",
    cp_talent_analytics_detail_empty_title: "Dieser Gruppenbericht existiert nicht oder Sie sind nicht berechtigt, ihn anzusehen",
    cp_talent_analytics_detail_empty_text: "Gehen Sie zur Talentanalyse-Übersicht, um die Gruppenberichte zu sehen, die es gibt und auf die Sie Zugriff haben.",
    cp_talent_analytics_detail_empty_redirect_button: "Zu Talent Analytics",
    cp_talent_analytics_share_report_modal_display_users_empty: "Sie teilen diesen Bericht noch mit niemandem.",
    cp_talent_analytics_share_report_modal_add_access_success_message: "Benachrichtigung wurde an den Benutzer gesendet",
    cp_talent_analytics_share_report_modal_invite_user_success_message: "Einladung wurde verschickt",
    cp_talent_analytics_share_report_modal_remove_user_success_message: "Der Zugang wird entfernt",
    cp_talent_analytics_no_feature_empty_title: "Sie haben keinen Zugriff auf die Übersicht und die Tools von Talent Analytics",
    cp_talent_analytics_no_feature_empty_text: "Um mehr über diese Übersicht und die Möglichkeit von Talent Analytics zu erfahren, klicken Sie auf die Schaltfläche unten",
    cp_talent_analytics_no_feature_empty_redirect_button: "Mehr Info",
    cp_talent_analytics_new_group_report: "New group report",
    cp_talent_analytics_create_new_modal_step1_title: "Step 1: What kind of report do you want?",
    cp_talent_analytics_create_new_modal_step2_title: "Step 2: Which people should be included in the report?",
    cp_talent_analytics_create_new_modal_select_type_title: "Which type of report do you want to create?",
    cp_talent_analytics_create_new_modal_name_title: "What is the name of the report?",
    cp_talent_analytics_create_new_modal_name_placeholder: "Name of the report",
    cp_talent_analytics_create_new_modal_step2_body: "Select the group(s) you want to include",
    cp_talent_analytics_create_new_modal_search_groups_placeholder: "Search groups",
    cp_talent_analytics_create_new_modal_selected_groups: "Selected groups",
    cp_talent_analytics_create_new_modal_button_create_report: "Create report",
    cp_talent_analytics_create_new_modal_button_cancel: "Cancel",
    cp_talent_analytics_create_new_modal_button_back: "Back",
    cp_talent_analytics_create_new_modal_button_select_groups: "Select groups",
    cp_talent_analytics_create_new_group_report_error: "Something went wrong while creating the new group report, please try again later.",
    cp_talent_analytics_create_new_group_report_success: "The group report was successfully created.",
    cp_talent_analytics_fetch_available_groups_error: "Something went wrong while fetching available groups, please try again later.",
    cp_talent_analytics_share_report_modal_warning: "Wenn Sie diesen Gruppenbericht freigeben, kann der Empfänger alle Informationen aus dem Bericht sehen. Stellen Sie sicher, dass die Person, die Sie einladen, über die Berechtigung verfügt, die Informationen im Gruppenbericht anzuzeigen.",
    cp_talent_analytics_share_report_modal_add_new_user_without_select_button: "Benutzer zum Anzeigen dieses Gruppenberichts einladen",
    cp_talent_analytics_loading_chip: "Laden...",
    cp_participants_dashboards_label_you: "",
    cp_participants_dashboards_label_positive_predictors_intro00: "",
    cp_participants_dashboards_label_positive_predictors_intro01: "",
    cp_participants_dashboards_label_positive_predictors_intro02: "",
    cp_participants_dashboards_label_positive_predictors_intro03: "",
    cp_participants_dashboards_label_positive_predictors_list1: "",
    cp_participants_dashboards_label_group_1: "",
    cp_participants_dashboards_label_group_2: "",
    cp_participants_dashboards_prediction_percentage_left1: "",
    cp_participants_dashboards_prediction_percentage_left2: "",
    cp_participants_dashboards_prediction_percentage_left3: "",
    cp_participants_dashboards_prediction_percentage_left4: "",
    cp_participants_dashboards_prediction_percentage_right1: "",
    cp_participants_dashboards_prediction_percentage_right2: "",
    cp_participants_dashboards_prediction_percentage_right3: "",
    cp_participants_dashboards_prediction_percentage_right4: "",
    cp_participants_dashboards_label_group_characteristics: "",
    cp_participants_dashboards_label_group_border: "",
    cp_participants_dashboards_applicant_prediction_label: "",
    cp_participants_dashboards_label_ml_outcome0: "",
    cp_participants_dashboards_label_ml_outcome1: "",
    cp_participants_dashboards_label_ml_outcome2: "",
    cp_participants_dashboards_label_ml_outcome3: "",
    cp_participants_dashboards_label_ml_outcome4: "",
    cp_participants_dashboards_label_ml_outcome5: "",
    cp_participants_dashboards_label_ml_applicants_intro: "",
    cp_participants_dashboards_label_ml_applicants_explanation1: "",
    cp_participants_dashboards_label_ml_applicants_explanation2: "",
    cp_participants_dashboards_title_group_membership_prediction_start: "",
    cp_participants_dashboards_title_group_membership_prediction_predictors_result: "",
    cp_participants_dashboards_title_group_membership_prediction_model_applied_members_result: "",
    cp_participants_dashboards_title_group_membership_prediction_model_performance_result: "",
    cp_participants_dashboards_title_group_membership_prediction_model_applied_applicants_result: "",
    cp_participants_dashboards_label_ml_members_explanation1: "",
    cp_participants_dashboards_label_ml_members_explanation2: "",
    cp_participants_dashboards_label_ml_members_intro: "",
    cp_participants_dashboards_label_negative_predictors_list2: "",
    cp_participants_dashboards_label_group_jobgroup_fit_prediction: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit: "",
    cp_participants_dashboards_label_group_jobgroup_fit_not: "",
    cp_participants_dashboards_prediction_prevalences_0: "",
    cp_participants_dashboards_prediction_prevalences_1: "",
    cp_participants_dashboards_prediction_prevalences_2: "",
    cp_participants_dashboards_prediction_prevalences_3: "",
    cp_participants_dashboards_prediction_prevalences_legend_name: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_beleid_organisatie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_beveiliging_en_bewaking: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_facilitaire_zaken: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_gezondheid: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_inkoop: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_productie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_kwaliteitscontrole_veiligheid: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_logistiek_transport_vervoer: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_management_business: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_marketing: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_onderwijs_training: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_onderzoek_wetenschap: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_sales_verkoop: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_technisch: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_executive: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_bouwnijverheid: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_cultuur_sport_en_recreatie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_energievoorziening: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_financiele_dienstverlening: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_gezondheids_en_welzijnszorg: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_kandel: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_koreca: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_industrie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_informatie_en_communicatie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_landbouw_bosbouw_en_visserij: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_onderwijs: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_onroerend_goed_verhuur_en_handel: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_openbaar_bestuur_en_overheidsdiensten: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_overige_dienstverlening: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_specialistische_zakelijke_diensten: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_verhuur_en_overige_zakelijke_diensten: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_vervoer_en_opslag: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_waterbedrijven_en_afvalbeheer: "",
    cp_participants_dashboards_prediction_related_competencies_intro: "",
    cp_participants_dashboards_prediction_related_competencies_are: "",
    cp_participants_dashboards_prediction_related_competencies_legend_name: "",
    cp_participants_dashboards_legend_age55plus: "",
    cp_participants_dashboards_legend_show_benchmark: "",
    cp_participants_dashboards_benchmark_comparision_norm_group: "",
    cp_participants_dashboards_benchmark_more_than_one_group: "",
    cp_participants_dashboards_recalculation_warning: "",
    cp_participants_dashboards_title_lasso_calculated_main_profile_of_group: "",
    cp_participants_dashboards_related_competencies_not_clear: "",
    cp_participants_dashboards_no_profile_can_be_calculated: "",
    cp_participants_dashboards_these_are_low_competency_scores: "",
    cp_participants_dashboards_there_are_no_low_competency_scores: "",
    cp_talent_analytics_settings_status_draft: "Draft",
    cp_talent_analytics_settings_status_published: "Published",
    cp_talent_analytics_settings_button_open_report: "Open",
    cp_talent_analytics_settings_form_section_report_title: "Report details",
    cp_talent_analytics_settings_form_section_report_description: "Here you can find all the settings for this report. Things like which report it is and how certain elements in the report are displayed",
    cp_talent_analytics_settings_form_section_settings_title: "Settings",
    cp_talent_analytics_settings_form_section_settings_description: "Here you can find all the settings for this report. Things like which report it is and how certain elements in the report are displayed.",
    cp_talent_analytics_settings_form_field_report_name: "Name of the report",
    cp_talent_analytics_settings_form_field_report_type: "Type of the report",
    cp_talent_analytics_settings_form_field_report_type_option_basic: "Basic",
    cp_talent_analytics_settings_form_field_report_type_option_basic_description: "A basic report that shows the most important information.",
    cp_talent_analytics_settings_form_field_report_type_option_team: "Team",
    cp_talent_analytics_settings_form_field_report_type_option_team_description: "A report that shows the performance of a team.",
    cp_talent_analytics_settings_form_field_report_type_option_ranking: "Ranking",
    cp_talent_analytics_settings_form_field_report_type_option_ranking_description: "A report that shows a ranking of participants of a selection assessment",
    cp_talent_analytics_settings_form_field_report_type_option_other: "Other",
    cp_talent_analytics_settings_form_field_report_type_option_other_description: "A report that shows other information.",
    cp_talent_analytics_settings_form_field_report_type_option_lasso: "Lasso",
    cp_talent_analytics_settings_form_field_report_type_option_lasso_description: "A report that shows the performance of a team.",
    cp_talent_analytics_settings_form_field_report_type_option_benchmark: "Benchmark",
    cp_talent_analytics_settings_form_field_report_type_option_benchmark_description: "A report that shows the performance of a team.",
    cp_talent_analytics_settings_form_field_report_published: "Published",
    cp_talent_analytics_settings_form_field_report_published_description: "When the report is published, it is visible to everyone who has access to the report.",
    cp_talent_analytics_settings_form_unsaved: "Your changes have not yet been saved",
    cp_talent_analytics_settings_form_saved: "Your changes have been saved",
    cp_talent_analytics_settings_form_button_save: "Save",
    cp_participants_dashboards_title_main_intro_teamsession: "",
    cp_participants_dashboards_title_culture_intro_teamsession: "",
    cp_participants_dashboards_title_dynamics_intro_teamsession: "",
    cp_participants_dashboards_title_roles_intro_teamsession: "",
    cp_participants_dashboards_no_positive_predictors_available: "",
    cp_participants_dashboards_mainIntroText1: "",
    cp_participants_dashboards_mainIntroText2: "",
    cp_participants_dashboards_mainIntroText21: "",
    cp_participants_dashboards_mainTntroText22: "",
    cp_participants_dashboards_mainIntroText23: "",
    cp_participants_dashboards_cultureIntroText: "",
    cp_participants_dashboards_groupDynamicsIntroText: "",
    cp_participants_dashboards_rolesIntroText: "",
    cp_participants_dashboards_label_negative_predictors_main_profile: "",
    cp_participants_dashboards_label_positive_predictors_main_profile: "",
    cp_talent_analytics_settings_form_section_groups_title: "",
    cp_talent_analytics_settings_form_section_groups_description: "",
    cp_talent_analytics_settings_form_group_edit_description: "",
    cp_talent_analytics_settings_form_group_edit_about_this_group: "",
    cp_talent_analytics_settings_form_group_edit_remove_member: "",
    cp_talent_analytics_settings_form_group_edit_subtitle: "",
    cp_talent_analytics_settings_form_group_edit_search_members: "",
    cp_talent_analytics_settings_form_group_edit_no_members_title: "",
    cp_talent_analytics_settings_form_group_edit_no_members_subtitle: "",
    cp_participants_dashboards_label_control_culture2: "",
    cp_participants_dashboards_label_innovation_culture2: "",
    cp_participants_dashboards_label_harmony_culture2: "",
    cp_participants_dashboards_label_result_culture2: "",
    cp_participants_dashboards_label_autonomous_self_management2: "",
    cp_participants_dashboards_label_docile_self_management2: "",
    cp_participants_dashboards_label_confident_self_management2: "",
    cp_participants_dashboards_label_self_criticism_self_management2: "",
    cp_participants_dashboards_label_conservative_innovation_power2: "",
    cp_participants_dashboards_label_progressive_innovation_power2: "",
    cp_participants_dashboards_label_decisiveness_innovation_power2: "",
    cp_participants_dashboards_label_thoughtful_innovation_power2: "",
    cp_participants_dashboards_label_socially_compliant_communication_styles2: "",
    cp_participants_dashboards_label_socially_resilient_communication_styles2: "",
    cp_participants_dashboards_label_candid_communication_styles2: "",
    cp_participants_dashboards_label_diplomatic_communication_styles2: "",
    cp_participants_dashboards_label_little_focus_self_interest_conflict_management2: "",
    cp_participants_dashboards_label_strong_focus_self_interest_conflict_management2: "",
    cp_participants_dashboards_label_little_focus_on_relationship_conflict_management: "",
    cp_participants_dashboards_label_strong_focus_on_relationship_conflict_management2: "",
    cp_participants_dashboards_important_percentages: "",
    cp_participants_dashboards_less_important_percentages: "",
    cp_participants_dashboards_roles_highest_avarage_scores: "",
    cp_participants_dashboards_roles_lowest_avarage_scores: "",
    cp_participants_dashboards_show_chart_explantion_text: "",
    cp_participants_dashboards_dominance_distribution_equal: "",
    cp_participants_dashboards_dominance_distribution_lower: "",
    cp_participants_dashboards_dominance_distribution_higher: "",
    cp_participants_dashboards_culturechart1_chartexplanation: "",
    cp_participants_dashboards_culturechart2_chartexplanation: "",
    cp_participants_dashboards_dominancepyramid_chartexplanation: "",
    cp_participants_dashboards_selfmanagement_chartexplanation: "",
    cp_participants_dashboards_communicationstyles_chartexplanation: "",
    cp_participants_dashboards_innovationpower_chartexplanation: "",
    cp_participants_dashboards_conflictmanagement_chartexplanation: "",
    cp_participants_dashboards_short_summary_intro: "",
    cp_participants_dashboards_dominance_distribution_higher_shortsummary: "",
    cp_participants_dashboards_dominance_distribution_lower_shortsummary: "",
    cp_participants_dashboards_dominance_distribution_labourmarket_shortsummary: "",
    cp_participants_dashboards_dominance_distribution_equal_shortsummary: "",
    cp_participants_dashboards_number_of_participants_shortsummary: "",
    cp_participants_dashboards_shortsummary_main_culture: "",
    cp_talent_analytics_settings_form_field_show_all_charts: "",
    cp_talent_analytics_settings_form_field_show_all_charts_description: "",
    cp_talent_analytics_settings_form_field_show_initials: "",
    cp_talent_analytics_settings_form_field_show_initials_description: "",
    cp_talent_analytics_settings_form_field_show_names: "",
    cp_talent_analytics_settings_form_field_show_names_description: "",
    cp_talent_analytics_settings_form_field_show_names_to_ltp: "",
    cp_talent_analytics_settings_form_field_show_names_to_ltp_description: "",
    cp_participants_dashboards_label_little_focus_on_relationship_conflict_management2: "",
    cp_participants_dashboards_toxics_lowest_avarage_scores: "",
    cp_participants_dashboards_toxics_highest_avarage_scores: "",
    cp_participants_dashboards_toxicsIntroText: "",
    cp_participants_dashboards_title_intro_benchmark: "",
    cp_participants_dashboards_title_toxics_intro_teamsession: "",
    cp_participants_dashboards_mainIntroText2_boardscan: "",
    cp_talent_analytics_create_new_modal_available_groups: "",
    cp_talent_analytics_create_new_modal_step1_description: "",
    cp_talent_analytics_create_new_modal_step2_description: "",
    cp_participants_dashboards_benchmarkIntroText: "",
    cp_participants_dashboards_label_group_jobgroup_fit_with: "",
    cp_participants_dashboards_total_group_name: "",
    cp_participants_dashboards_status_group_hired: "",
    cp_participants_dashboards_status_group_non_hired: "",
    cp_participants_dashboards_status_group_in_consideration: "",
    cp_participants_dashboards_groupreportname_organisation_analysis_culture_insights: "",
    cp_participants_dashboards_reflection_summary: "",
    cp_participants_dashboards_reflection_total_number_of_texts: "",
    cp_participants_dashboards_reflection_neutral: "",
    cp_participants_dashboards_reflection_positive: "",
    cp_participants_dashboards_reflection_negative: ""
};
